import LinkView from '../../../../../components/Views/LinkView/LinkView';

export default LinkView;
